import type { EnDictionary } from './en';
import { eoIt } from './eo';
import { profileIt } from './profile';

export const it: EnDictionary = {
  'common.loading': 'Caricamento…',
  'common.signIn': 'Accedi',
  'common.signOut': 'Esci',
  'common.signUp': 'Registrati',
  'common.continue': 'Continua',
  'common.back': 'Indietro',
  'common.cancel': 'Annulla',
  'common.submit': 'Invia',
  'common.email': 'Email',
  'common.password': 'Password',
  'common.confirmPassword': 'Conferma password',
  'common.fullName': 'Nome completo',
  'common.phone': 'Telefono',
  'common.companyName': 'Nome azienda',
  'common.required': 'Obbligatorio',
  'common.errorBoundary.title': 'Qualcosa è andato storto',
  'common.errorBoundary.message':
    'La pagina ha riscontrato un errore imprevisto. Ricarica e riprova.',
  'common.errorBoundary.reload': 'Ricarica pagina',

  'marketing.eyebrow': 'Wellness · Sport · Cultura',
  'marketing.heroTitle': 'Wellness, Sport & Cultura in Italia',
  'marketing.heroSub':
    'Esperienze trasformative in luoghi iconici tra mare, borghi e montagne, pensate per persone, team e realtà aziendali che vogliono rigenerarsi.',
  'marketing.requestProposal': 'Richiedi una proposta',
  'marketing.exploreExperiences': 'Scopri le esperienze',
  'marketing.pillarsTitle': 'Rigenerazione, Sport & Cultura',
  'marketing.pillarsSub':
    'Programmi costruiti insieme alle strutture ospitanti e ai professionisti, per portare benessere concreto a persone, team e ospiti.',
  'marketing.pillar.regenerationTitle': 'Rigenerazione',
  'marketing.pillar.regenerationDesc':
    'Percorsi che riducono stress, migliorano equilibrio e salute attraverso pratiche di mindfulness, yoga, breathwork e momenti di ascolto.',
  'marketing.pillar.sportTitle': 'Sport & Natura',
  'marketing.pillar.sportDesc':
    'SUP, trekking, yoga e discipline emergenti in scenari unici tra mare, laghi e montagne.',
  'marketing.pillar.cultureTitle': 'Cultura & Gastronomia',
  'marketing.pillar.cultureDesc':
    'Immersione in patrimoni locali, arte e sapori autentici con guide, artigiani e realtà del territorio selezionate.',
  'marketing.trustTitle': 'Trust & Impact',
  'marketing.trustSub':
    'Programmi progettati con facilitazione evidence-based e obiettivi di business chiari per benessere e performance.',

  'login.title': 'Accedi',
  'login.subtitle': 'Accedi con email e password',
  'login.failed': 'Accesso non riuscito',
  'login.signingIn': 'Accesso in corso…',
  'login.noAccount': 'Non hai ancora un account?',

  'signup.title': 'Registrati',
  'signup.subtitle': 'Completa la registrazione in tre passaggi guidati',
  'signup.step1Title': 'I tuoi dati',
  'signup.step2Title': 'La tua azienda',
  'signup.step3Title': 'Conferma',
  'signup.step1Desc': 'Informazioni di base per iniziare.',
  'signup.step2Desc': 'Raccontaci della tua azienda e seleziona un ruolo.',
  'signup.step3Desc': 'Rivedi i dati prima di creare l\'account.',
  'signup.companyRole': 'Ruolo aziendale',
  'signup.create': 'Crea account',
  'signup.creating': 'Registrazione in corso…',
  'signup.failed': 'Registrazione non riuscita',
  'signup.haveAccount': 'Hai già un account?',
  'signup.role.customer': 'Cliente',
  'signup.role.customerDesc':
    'Trova e acquista pacchetti esperienza adatti al tuo team.',
  'signup.role.travelAgency': 'Agenzia di viaggi',
  'signup.role.travelAgencyDesc':
    'Organizza eventi e pubblica pacchetti integrati.',
  'signup.role.eventOrganizer': 'Event Organizer',
  'signup.role.eventOrganizerDesc':
    'Crea e gestisci modelli di pacchetti evento.',
  'signup.role.facilityProvider': 'Struttura ospitante',
  'signup.role.facilityProviderDesc':
    'Offri sedi, alloggi e servizi correlati.',
  'signup.role.serviceProvider': 'Service Provider',
  'signup.role.serviceProviderDesc':
    'Offri servizi guidati, wellness, logistica o correlati.',
  'signup.role.researchPartner': 'Research Partner',
  'signup.role.researchPartnerDesc':
    'Fornisci misurazioni, analisi e reportistica.',

  'authAction.verifying': 'Verifica email in corso…',
  'authAction.successTitle': 'Email verificata!',
  'authAction.successDesc': 'Il tuo account è attivo. Reindirizzamento alla dashboard…',
  'authAction.expiredTitle': 'Link scaduto',
  'authAction.expiredDesc': 'Questo link di verifica è scaduto. Richiedine uno nuovo.',
  'authAction.invalidTitle': 'Link non valido',
  'authAction.invalidDesc': 'Questo link è non valido o è già stato utilizzato.',
  'authAction.errorTitle': 'Verifica non riuscita',
  'authAction.errorDesc': 'Qualcosa è andato storto. Riprova.',
  'authAction.unsupportedTitle': 'Azione non supportata',
  'authAction.unsupportedDesc': 'Questo tipo di link non è supportato.',
  'authAction.goToLogin': 'Vai al login',
  'authAction.resendLink': 'Richiedi una nuova email di verifica',

  'verifyEmail.title': 'Controlla la tua casella email',
  'verifyEmail.desc': 'Abbiamo inviato un link di verifica a',
  'verifyEmail.desc2': 'Clicca il link per attivare il tuo account, poi torna qui.',
  'verifyEmail.resend': 'Invia di nuovo l\'email di verifica',
  'verifyEmail.resending': 'Invio in corso…',
  'verifyEmail.resendSuccess': 'Email di verifica inviata. Controlla la tua casella.',
  'verifyEmail.resendError': 'Invio non riuscito. Riprova.',
  'verifyEmail.checkVerified': 'Ho verificato la mia email',
  'verifyEmail.checking': 'Verifica in corso…',
  'verifyEmail.notYetVerified': 'L\'email non è ancora verificata. Clicca il link nell\'email.',
  'verifyEmail.backToLogin': 'Esci e torna al login',

  'dashboard.title': 'La mia dashboard',
  'dashboard.welcome': 'Bentornato',
  'dashboard.stats.activeProposals': 'Proposte attive',
  'dashboard.stats.confirmedBookings': 'Prenotazioni confermate',
  'dashboard.stats.upcomingRetreats': 'Retreat in arrivo',
  'dashboard.stats.savedPackages': 'Pacchetti salvati',
  'dashboard.quickActionsTitle': 'Azioni rapide',
  'dashboard.action.companyProfile': 'Profilo azienda',

  'admin.login.title': 'Console amministratori',
  'admin.login.subtitle': 'Accedi alla console amministratori N-Excelsior.',
  'admin.login.failed': 'Accesso non riuscito',
  'admin.login.forbidden':
    'Questo account non è autorizzato ad accedere alla console.',
  'admin.changePassword.title': 'Imposta una nuova password',
  'admin.changePassword.subtitle':
    'Per sicurezza, modifica la password iniziale prima di continuare.',
  'admin.changePassword.current': 'Password attuale',
  'admin.changePassword.new': 'Nuova password',
  'admin.changePassword.confirm': 'Conferma nuova password',
  'admin.changePassword.submit': 'Aggiorna password',
  'admin.changePassword.submitting': 'Aggiornamento…',
  'admin.changePassword.tooShort': 'La password deve contenere almeno 10 caratteri.',
  'admin.changePassword.forbidden':
    'Scegli una password diversa da quella di default.',
  'admin.changePassword.mismatch': 'Le password non coincidono.',
  'admin.changePassword.sameAsCurrent':
    'La nuova password deve essere diversa da quella attuale.',
  'admin.changePassword.currentRequired': 'Inserisci la password attuale.',
  'admin.dashboard.title': 'Dashboard amministratori',
  'admin.dashboard.subtitle':
    'Panoramica operativa della piattaforma N-Excelsior.',
  'admin.dashboard.kpi.users': 'Utenti totali',
  'admin.dashboard.kpi.companies': 'Aziende',
  'admin.dashboard.kpi.pending': 'In revisione',
  'admin.dashboard.kpi.reports': 'Report',
  'admin.dashboard.recentTitle': 'Registrazioni recenti',
  'admin.nav.users': 'Utenti',
  'admin.nav.companies': 'Aziende',
  'admin.nav.operators': 'Operatori',
  'admin.nav.audit': 'Audit log',

  ...eoIt,
  ...profileIt,
};
